import { createNewAllergen } from "../../../store/Dish/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useCreateNewAllergen = () => {
    const queryClient = useQueryClient();

    return useMutation(["addNewAllergen"], ({ name }) => createNewAllergen(name), {
        onSuccess: async () => {
            await queryClient.invalidateQueries(["allergens"]);
        },
    });
};
